<template lang="pug">
v-text-field.suus__select(
    :placeholder="placeholder",
    color=color,
    filled,
    persistent-placeholder,
    :value="inputValue",
    background-color="lightGrey",
    :disabled="disabled",
    v-on="$listeners",
    v-bind="$attrs"
    :rules="rules"
)
    template(v-slot:label)
        FieldLabel.suus__select__label(:mandatory="mandatory", :label="label")
</template>

<script lang="ts">
import Vue from "vue"
import FieldLabel from "../../../components/UI/FieldLabel.vue"
export default Vue.extend({
  name: "InputField",
  components: { FieldLabel },
  props: {
    placeholder: { type: String, default: "" },
    mandatory: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, required: true },
    value: { type: String, default: null },
    rules: { type: Array, default: () => [] },
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  watch: {
    value(val: string) {
      this.inputValue = val
    },
    inputValue(val: string) {
      this.$emit("input", val)
    },
  },
})
</script>

<style lang="sass" scoped>
%font-stack
    font-family: system-ui !important
.suus__select::v-deep input
    @extend %font-stack
    font-size: 1.2rem !important
    font-weight: 300
.suus__select::v-deep .v-label
    top: 15px
</style>
